/**
 * @description Hook to check if payment processing is configured for the current company.
 *
 * Key features:
 * - Returns true (configured), false (not configured), or null (loading)
 * - Fetches once on mount, caches result for the component lifecycle
 * - Gracefully handles errors (returns false — safer to hide than crash)
 *
 * @dependencies
 * - gatewaysService.getPaymentStatus: GET /gateways/payment-status
 *
 * @notes
 * - Used by PaymentRecorder (guard Process Card tab) and MerchantDashboard (hide New Payment)
 * - Does NOT cache across components — each consumer fetches independently
 *   (lightweight endpoint, no heavy query)
 */

import { useState, useEffect } from 'react';
import gatewaysService from '../services/api/gatewayServices';

const usePaymentStatus = () => {
  const [paymentConfigured, setPaymentConfigured] = useState(null);

  useEffect(() => {
    gatewaysService.getPaymentStatus()
      .then(data => setPaymentConfigured(data.configured))
      .catch(() => setPaymentConfigured(false));
  }, []);

  return paymentConfigured;
};

export default usePaymentStatus;
